import stepUsage from './advance_pricing/stepUsage';
import tierUsage from './advance_pricing/tierUsage';
import volumeUsage from './advance_pricing/volumeUsage';

function advancePricing(price, minimumPrice) {
  return price > minimumPrice ? price : minimumPrice;
}

function calculatePrice(pricingSchema, quantity) {
  const {
    price,
    schema_type: schemaType,
    pricing_ranges: ranges,
  } = pricingSchema;
  const minimumPrice = Number(pricingSchema.minimum_price);

  switch (schemaType) {
    case 'step_usage':
      return advancePricing(stepUsage(ranges, quantity, price), minimumPrice);

    case 'volume_usage':
      return advancePricing(volumeUsage(ranges, quantity, price), minimumPrice);

    case 'tier_usage':
      return advancePricing(tierUsage(ranges, quantity, price), minimumPrice);

    default:
      return price * quantity;
  }
}

export default calculatePrice;
